import React from 'react'
import styled from 'styled-components';
import Stars from '../../icons/Stars.svg'

const Section = styled.section`
    margin-bottom: 8rem !important;
    .container {
        background-color: var(--peach);
    }

    svg {
        fill: var(--orange);
        height: 80px;
    }

    p {
        font-size: 28px;
        margin: 2rem 0;
        & span { color: var(--orange) }
    }

    @media (max-width: 768px) {
        margin-bottom: 4rem !important;
        h4, p { font-size: 21px; }
    }

    @media (max-width: 576px) {
        margin-bottom: 0 !important;
    }
`;

const Quote = () => {
    return (
        <Section>
            <div className="container py-5">
                <div className="row text-center">
                    <div className="col-11 mx-auto d-flex flex-column align-items-center">
                        <Stars />
                        <p>
                            <span>“</span>I believe nearly every company will derive a significant portion of its revenue from financial services. Every company, even those that have nothing to do with financial services, will have the opportunity to benefit from fintech for the first time.<span>”</span>
                        </p>
                        <h4>- Andreessen Horowitz</h4>
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default Quote
